/** In-app inbox behind the header bell (/api/notifications/*) — see api notifications + push modules. */
import type { ApiResponse, ComposeNotificationInput, ComposeNotificationResult, NotificationComposeLogDto, NotificationListResponse } from '@system/shared'
import { apiFetch } from './api-client-core'

export function listNotifications(): Promise<ApiResponse<NotificationListResponse>> {
  return apiFetch('/api/notifications')
}

export function markNotificationRead(id: string): Promise<ApiResponse<{ ok: boolean }>> {
  return apiFetch(`/api/notifications/${encodeURIComponent(id)}/read`, { method: 'POST' })
}

export function markAllNotificationsRead(): Promise<ApiResponse<{ ok: boolean }>> {
  return apiFetch('/api/notifications/read-all', { method: 'POST' })
}

/** Manual announcement (Site Content → Thông báo; cmo/hr). */
export function composeNotification(input: ComposeNotificationInput): Promise<ApiResponse<ComposeNotificationResult>> {
  return apiFetch('/api/notifications/compose', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  })
}

export function getNotificationComposeLog(): Promise<ApiResponse<NotificationComposeLogDto[]>> {
  return apiFetch('/api/notifications/compose/log')
}
